import i18next from 'i18next';

export const NoMedicalConditionId = 25;
export const NoMedicalConditionOption = {
  id: NoMedicalConditionId,
  name: i18next.t('no_conditions'),
};
